var React = require('react');

function CaretSquareRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-83.82 232L182.29 380.65c-8.22 7.16-22.29 2.09-22.29-8V139.4c0-10.14 14.06-15.21 22.29-8.05L316.18 248a10.38 10.38 0 0 1 0 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M316.18 264L182.29 380.65c-8.22 7.16-22.29 2.09-22.29-8V139.4c0-10.14 14.07-15.21 22.29-8.05L316.18 248a10.38 10.38 0 0 1 0 16z","className":"fa-primary","key":2})]);
}

CaretSquareRight.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = CaretSquareRight;

CaretSquareRight.default = CaretSquareRight;
